import React from 'react';
import { Button } from '../../../../components/shared';

interface TrainingNotFoundStateProps {
  onBack?: () => void;
  className?: string;
}

/**
 * Component for displaying training not found state
 */
export const TrainingNotFoundState: React.FC<TrainingNotFoundStateProps> = ({
  onBack,
  className = '',
}) => {
  return (
    <div
      className={`min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 pb-20 flex items-center justify-center ${className}`}
    >
      <div className="text-center">
        <div className="text-red-500 text-4xl mb-4">⚠️</div>
        <p className="text-gray-600 mb-4">Тренировка не найдена</p>
        {onBack && <Button onClick={onBack}>Назад</Button>}
      </div>
    </div>
  );
};
